(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mdlc-product-wheel"] && !Shopify.designMode) return;
  try {
    (() => {
    const labels = {
      coupe: ['coupe'],
      entretien: ['matière', 'entretien'],
      tailles: ['taille'],
      livraison: ['livraison', 'expédition'],
      retours: ['retour', 'remboursement']
    };
    const order = ['coupe', 'entretien', 'tailles', 'livraison', 'retours'];

    const keyForLabel = (label) => {
      const normalized = label.toLocaleLowerCase('fr');
      return order.find((key) => labels[key].some((term) => normalized.includes(term)));
    };

    const createBubble = (source, key) => {
      const bubble = document.createElement('details');
      bubble.className = 'mdlc-bubble';
      bubble.dataset.mdlcBubbleKey = key;

      const summary = document.createElement('summary');
      summary.className = 'mdlc-bubble__summary';

      const dot = document.createElement('span');
      dot.className = 'mdlc-bubble__dot';
      dot.setAttribute('aria-hidden', 'true');

      const bubbleLabel = document.createElement('span');
      bubbleLabel.className = 'mdlc-bubble__label';
      bubbleLabel.textContent = source.label;

      const toggle = document.createElement('span');
      toggle.className = 'mdlc-bubble__toggle';
      toggle.setAttribute('aria-hidden', 'true');

      const content = document.createElement('div');
      content.className = 'mdlc-bubble__content rte';
      content.innerHTML = source.html;

      summary.append(dot, bubbleLabel, toggle);
      bubble.append(summary, content);
      return bubble;
    };

    const enhanceTicker = (root) => {
      const highlights = root.querySelector('.product__tags');
      if (!highlights || highlights.querySelector('.mdlc-bullets-track')) return;

      const originals = Array.from(highlights.children);
      if (!originals.length) return;

      const track = document.createElement('div');
      track.className = 'mdlc-bullets-track';
      originals.forEach((item) => track.appendChild(item));
      highlights.appendChild(track);

      for (let copyIndex = 0; copyIndex < 2; copyIndex += 1) {
        originals.forEach((item) => {
          const copy = item.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          track.appendChild(copy);
        });
      }

      window.requestAnimationFrame(() => {
        const first = track.children[0];
        const repeated = track.children[originals.length];
        if (!first || !repeated) return;

        const distance = repeated.offsetLeft - first.offsetLeft;
        track.style.setProperty('--mdlc-ticker-distance', `${distance}px`);
        track.style.setProperty('--mdlc-ticker-duration', `${Math.max(18, distance / 34)}s`);
      });
    };

    const enhanceTickerLoupe = (root, reduceMotion) => {
      const highlights = root.querySelector('.product__tags');
      const track = highlights?.querySelector('.mdlc-bullets-track');
      if (!highlights || !track || track.dataset.mdlcLoupeReady === 'true') return;

      track.dataset.mdlcLoupeReady = 'true';
      const items = Array.from(track.querySelectorAll('.product__tag'));
      if (!items.length || reduceMotion) return;

      let frameId;
      let isVisible = false;

      const render = () => {
        frameId = undefined;
        if (!isVisible || document.hidden || !track.isConnected) return;

        const viewportRect = highlights.getBoundingClientRect();
        const viewportCenter = viewportRect.left + viewportRect.width / 2;
        const influence = Math.max(90, viewportRect.width * 0.3);

        items.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const itemCenter = rect.left + rect.width / 2;
          const proximity = 1 - Math.min(1, Math.abs(itemCenter - viewportCenter) / influence);
          const emphasis = proximity * proximity * (3 - 2 * proximity);
          const scale = 1 + emphasis * 0.34;

          item.style.setProperty('--mdlc-center-scale', scale.toFixed(3));
          item.style.opacity = String(0.78 + emphasis * 0.22);
          item.style.zIndex = String(Math.round(emphasis * 10));
        });

        frameId = window.requestAnimationFrame(render);
      };

      const start = () => {
        if (frameId === undefined) frameId = window.requestAnimationFrame(render);
      };

      const stop = () => {
        if (frameId !== undefined) window.cancelAnimationFrame(frameId);
        frameId = undefined;
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          isVisible = entry.isIntersecting;
          if (isVisible && !document.hidden) start();
          else stop();
        }, { rootMargin: '80px 0px' });
        observer.observe(highlights);
      } else {
        isVisible = true;
        start();
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else if (isVisible) start();
      });
    };

    const enhanceBubbleLoupe = (viewport, track, reduceMotion) => {
      if (track.dataset.mdlcBubbleLoupeReady === 'true') return;

      track.dataset.mdlcBubbleLoupeReady = 'true';
      if (reduceMotion) return;

      let frameId;
      let isVisible = false;

      const render = () => {
        frameId = undefined;
        if (!isVisible || document.hidden || !track.isConnected) return;

        const viewportRect = viewport.getBoundingClientRect();
        const viewportCenter = viewportRect.top + viewportRect.height / 2;
        const influence = Math.max(64, viewportRect.height * 0.46);

        track.querySelectorAll('.mdlc-bubble').forEach((bubble) => {
          if (bubble.open) {
            bubble.style.setProperty('--mdlc-bubble-center-scale', '1');
            return;
          }

          const rect = bubble.getBoundingClientRect();
          const bubbleCenter = rect.top + rect.height / 2;
          const proximity = 1 - Math.min(1, Math.abs(bubbleCenter - viewportCenter) / influence);
          const emphasis = proximity * proximity * (3 - 2 * proximity);
          const scale = 1 + emphasis * 0.045;

          bubble.style.setProperty('--mdlc-bubble-center-scale', scale.toFixed(3));
          bubble.style.zIndex = String(Math.round(emphasis * 10));
        });

        frameId = window.requestAnimationFrame(render);
      };

      const start = () => {
        if (frameId === undefined) frameId = window.requestAnimationFrame(render);
      };

      const stop = () => {
        if (frameId !== undefined) window.cancelAnimationFrame(frameId);
        frameId = undefined;
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          isVisible = entry.isIntersecting;
          if (isVisible && !document.hidden) start();
          else stop();
        }, { rootMargin: '80px 0px' });
        observer.observe(viewport);
      } else {
        isVisible = true;
        start();
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else if (isVisible) start();
      });
    };

    const enhanceImageCarousel = (component, reduceMotion) => {
      const productShell = component.closest('product-info');
      if (!productShell) return;

      productShell.classList.add('mdlc-bubbles-product');
      const sourceGallery = productShell.querySelector('.custom-mdlc-gallery:not([data-mdlc-carousel-source])');
      if (!sourceGallery) return;

      const thumbnailImages = Array.from(sourceGallery.querySelectorAll('.mdlc-thumbs img'));
      const sourceImages = thumbnailImages.length
        ? thumbnailImages
        : Array.from(sourceGallery.querySelectorAll('#mdlc-main-img, img')).slice(0, 1);
      if (!sourceImages.length) return;

      sourceGallery.dataset.mdlcCarouselSource = 'true';
      const gallery = document.createElement('div');
      gallery.className = `mdlc-infinite-gallery${sourceImages.length === 1 ? ' is-single' : ''}`;

      const viewport = document.createElement('div');
      viewport.className = 'mdlc-infinite-gallery__viewport';
      viewport.tabIndex = 0;
      viewport.setAttribute('role', 'region');
      viewport.setAttribute('aria-roledescription', component.dataset.galleryName || 'Carrousel');
      viewport.setAttribute('aria-label', component.dataset.galleryLabel || 'Galerie produit');

      const track = document.createElement('div');
      track.className = 'mdlc-infinite-gallery__track';
      const productTitle = component.dataset.galleryProductTitle || '';
      const ofLabel = component.dataset.galleryOf || 'de';

      const imageData = sourceImages.map((image, imageIndex) => {
        const thumbnail = image.closest('.mdlc-thumb');
        const sourceWidth = Number(image.getAttribute('width'));
        const sourceHeight = Number(image.getAttribute('height'));
        const aspectRatio = sourceWidth > 0 && sourceHeight > 0 ? sourceWidth / sourceHeight : 0;

        return {
          alt: image.getAttribute('alt') || `${productTitle} — photo ${imageIndex + 1}`,
          src: thumbnail?.dataset.fullSrc || image.currentSrc || image.src,
          srcset: thumbnail?.dataset.fullSrcset || image.srcset || '',
          sizes: '(min-width: 990px) 55vw, 100vw',
          width: aspectRatio ? 1600 : undefined,
          height: aspectRatio ? Math.round(1600 / aspectRatio) : undefined
        };
      });
      const loopData = imageData.length > 1
        ? [imageData[imageData.length - 1], ...imageData, imageData[0]]
        : imageData;

      loopData.forEach((data, loopIndex) => {
        const slide = document.createElement('div');
        slide.className = 'mdlc-infinite-gallery__slide';
        const isLoopCopy = imageData.length > 1 && (loopIndex === 0 || loopIndex === loopData.length - 1);
        const logicalIndex = imageData.length === 1
          ? 0
          : (loopIndex - 1 + imageData.length) % imageData.length;

        if (isLoopCopy) {
          slide.setAttribute('aria-hidden', 'true');
        } else {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `${logicalIndex + 1} ${ofLabel} ${imageData.length}`);
        }

        const image = document.createElement('img');
        image.className = 'mdlc-infinite-gallery__image';
        image.src = data.src;
        if (data.srcset) {
          image.srcset = data.srcset;
          image.sizes = data.sizes;
        }
        if (data.width && data.height) {
          image.width = data.width;
          image.height = data.height;
        }
        image.alt = isLoopCopy ? '' : data.alt;
        image.draggable = false;
        image.decoding = 'async';
        image.loading = loopIndex === 1 ? 'eager' : 'lazy';
        image.fetchPriority = loopIndex === 1 ? 'high' : 'low';
        slide.appendChild(image);
        track.appendChild(slide);
      });

      viewport.appendChild(track);
      gallery.appendChild(viewport);

      const previousButton = document.createElement('button');
      previousButton.type = 'button';
      previousButton.className = 'mdlc-infinite-gallery__button mdlc-infinite-gallery__button--previous';
      previousButton.setAttribute('aria-label', component.dataset.galleryPrevious || 'Image précédente');
      previousButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.5 5-7 7 7 7"/></svg>';

      const nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'mdlc-infinite-gallery__button mdlc-infinite-gallery__button--next';
      nextButton.setAttribute('aria-label', component.dataset.galleryNext || 'Image suivante');
      nextButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 5 7 7-7 7"/></svg>';

      const counter = document.createElement('div');
      counter.className = 'mdlc-infinite-gallery__counter';
      counter.setAttribute('aria-live', 'polite');
      const counterCurrent = document.createElement('span');
      const counterSeparator = document.createElement('span');
      const counterTotal = document.createElement('span');
      counterSeparator.setAttribute('aria-hidden', 'true');
      counterSeparator.textContent = ' / ';
      counterTotal.textContent = String(imageData.length);
      counter.append(counterCurrent, counterSeparator, counterTotal);

      gallery.append(previousButton, nextButton, counter);
      sourceGallery.hidden = true;
      sourceGallery.after(gallery);

      let currentIndex = imageData.length > 1 ? 1 : 0;
      let autoTimer;
      let resumeTimer;
      let pointerId;
      let pointerStart = 0;
      let pointerDelta = 0;
      let dragged = false;
      let transitioning = false;
      let pointerImage;

      const logicalIndex = () => {
        if (imageData.length === 1) return 0;
        if (currentIndex === 0) return imageData.length - 1;
        if (currentIndex === imageData.length + 1) return 0;
        return currentIndex - 1;
      };

      const updateCounter = () => {
        counterCurrent.textContent = String(logicalIndex() + 1);
      };

      const positionTrack = (animate, dragOffset = 0) => {
        track.style.transition = animate && !reduceMotion
          ? 'transform 520ms cubic-bezier(0.22, 1, 0.36, 1)'
          : 'none';
        track.style.transform = `translate3d(${-(currentIndex * viewport.clientWidth) + dragOffset}px, 0, 0)`;
        updateCounter();
      };

      const clearZoom = () => gallery.querySelectorAll('.is-zoomed').forEach((image) => {
        image.classList.remove('is-zoomed');
        image.style.removeProperty('transform-origin');
      });

      const toggleZoom = (image, clientX, clientY) => {
        if (!image) return;

        const wasZoomed = image.classList.contains('is-zoomed');
        clearZoom();
        if (!wasZoomed) {
          const rect = image.parentElement.getBoundingClientRect();
          if (Number.isFinite(clientX) && Number.isFinite(clientY) && rect.width && rect.height) {
            const originX = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
            const originY = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
            image.style.transformOrigin = `${originX}% ${originY}%`;
          }
          image.classList.add('is-zoomed');
        }
        stopAuto();
      };

      const move = (direction) => {
        if (imageData.length < 2 || transitioning) return;
        clearZoom();
        transitioning = !reduceMotion;
        currentIndex += direction;
        positionTrack(true);
        if (reduceMotion) transitioning = false;
      };

      const stopAuto = () => {
        window.clearInterval(autoTimer);
        window.clearTimeout(resumeTimer);
      };

      const startAuto = () => {
        stopAuto();
        if (reduceMotion || imageData.length < 2 || !gallery.isConnected) return;
        autoTimer = window.setInterval(() => move(1), 3800);
      };

      const resumeLater = () => {
        stopAuto();
        resumeTimer = window.setTimeout(startAuto, 5200);
      };

      track.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'transform' || imageData.length < 2) return;
        if (currentIndex === 0) currentIndex = imageData.length;
        else if (currentIndex === imageData.length + 1) currentIndex = 1;
        transitioning = false;
        positionTrack(false);
      });

      previousButton.addEventListener('click', () => {
        move(-1);
        resumeLater();
      });
      nextButton.addEventListener('click', () => {
        move(1);
        resumeLater();
      });

      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
          resumeLater();
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          const activeSlide = track.children[currentIndex];
          toggleZoom(activeSlide?.querySelector('.mdlc-infinite-gallery__image'));
        }
      });

      viewport.addEventListener('pointerdown', (event) => {
        if (transitioning) return;
        pointerId = event.pointerId;
        pointerStart = event.clientX;
        pointerDelta = 0;
        dragged = false;
        pointerImage = event.target.closest('.mdlc-infinite-gallery__image');
        stopAuto();
        if (imageData.length > 1) {
          viewport.setPointerCapture(pointerId);
          track.style.transition = 'none';
        }
      });

      viewport.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId || imageData.length < 2) return;
        pointerDelta = event.clientX - pointerStart;
        if (Math.abs(pointerDelta) > 6) dragged = true;
        positionTrack(false, pointerDelta);
      });

      const finishDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        const shouldZoom = event.type !== 'pointercancel' && !dragged && pointerImage;

        if (imageData.length > 1) {
          const threshold = viewport.clientWidth * 0.16;
          if (Math.abs(pointerDelta) > threshold) currentIndex += pointerDelta < 0 ? 1 : -1;
          transitioning = !reduceMotion && Math.abs(pointerDelta) > threshold;
          positionTrack(true);
          if (reduceMotion || Math.abs(pointerDelta) <= threshold) transitioning = false;
        }

        const imageToZoom = shouldZoom ? pointerImage : undefined;
        pointerId = undefined;
        pointerDelta = 0;
        pointerImage = undefined;
        if (imageToZoom) toggleZoom(imageToZoom, event.clientX, event.clientY);
        else resumeLater();
      };

      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('pointerenter', stopAuto);
      viewport.addEventListener('pointerleave', resumeLater);
      viewport.addEventListener('focusin', stopAuto);
      viewport.addEventListener('focusout', resumeLater);

      gallery.querySelectorAll('.mdlc-infinite-gallery__image').forEach((image) => {
        image.addEventListener('pointermove', (event) => {
          if (!image.classList.contains('is-zoomed')) return;
          const rect = image.parentElement.getBoundingClientRect();
          image.style.transformOrigin = `${((event.clientX - rect.left) / rect.width) * 100}% ${((event.clientY - rect.top) / rect.height) * 100}%`;
        });
      });

      const resizeObserver = new ResizeObserver(() => positionTrack(false));
      resizeObserver.observe(viewport);
      positionTrack(false);
      startAuto();
    };

    const enhanceCartButton = (root, reduceMotion) => {
      const button = root.querySelector('.product-form__submit');
      if (!button || reduceMotion || button.dataset.mdlcBubbleButton === 'true') return;

      button.dataset.mdlcBubbleButton = 'true';
      let repeatTimer;
      let stopped = false;

      const pulse = () => {
        if (stopped || button.disabled) return;
        button.classList.remove('mdlc-cart-attention');
        window.requestAnimationFrame(() => button.classList.add('mdlc-cart-attention'));
      };

      const firstTimer = window.setTimeout(() => {
        pulse();
        repeatTimer = window.setInterval(pulse, 8000);
      }, 2000);

      const stop = () => {
        stopped = true;
        window.clearTimeout(firstTimer);
        window.clearInterval(repeatTimer);
        button.classList.remove('mdlc-cart-attention');
      };

      button.addEventListener('pointerdown', stop, { once: true });
      button.addEventListener('keydown', stop, { once: true });
      button.addEventListener('animationend', () => button.classList.remove('mdlc-cart-attention'));
    };

    const setupBubbles = (component) => {
      const root = component.closest('[id^="ProductInfo-"]');
      const viewport = component.querySelector('[data-mdlc-bubbles-viewport]');
      const track = component.querySelector('[data-mdlc-bubbles-track]');
      if (!root || !viewport || !track) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      enhanceTicker(root);
      enhanceTickerLoupe(root, reduceMotion);
      enhanceImageCarousel(component, reduceMotion);
      enhanceCartButton(root, reduceMotion);

      if (component.dataset.mdlcBubblesReady === 'true') return;

      component.dataset.mdlcBubblesReady = 'true';
      root.classList.add('mdlc-bubbles-active');

      const sources = {};
      root.querySelectorAll('.product__accordion').forEach((accordion) => {
        const title = accordion.querySelector('.accordion__title, summary');
        const content = accordion.querySelector('.accordion__content');
        if (!title || !content) return;

        const label = title.textContent.trim();
        const key = keyForLabel(label);
        if (!key || sources[key]) return;

        sources[key] = { label, html: content.innerHTML };
        accordion.hidden = true;
        accordion.setAttribute('aria-hidden', 'true');
      });

      order.forEach((key) => {
        if (sources[key]) track.appendChild(createBubble(sources[key], key));
      });

      const bubbles = Array.from(track.querySelectorAll('.mdlc-bubble'));
      let autoTimer;
      let resumeTimer;
      let activeIndex = 0;
      let autoDirection = 1;
      let pointerInside = false;
      let userControlled = false;

      enhanceBubbleLoupe(viewport, track, reduceMotion);

      const hasOpenBubble = () => bubbles.some((bubble) => bubble.open);

      const stopAuto = () => {
        window.clearInterval(autoTimer);
        window.clearTimeout(resumeTimer);
      };

      const takeManualControl = () => {
        userControlled = true;
        component.dataset.mdlcBubblesManual = 'true';
        stopAuto();
      };

      const startAuto = () => {
        stopAuto();
        if (
          reduceMotion ||
          userControlled ||
          component.dataset.mdlcBubblesManual === 'true' ||
          pointerInside ||
          hasOpenBubble() ||
          bubbles.length < 2
        ) return;

        autoTimer = window.setInterval(() => {
          if (component.dataset.mdlcBubblesManual === 'true') {
            stopAuto();
            return;
          }

          if (activeIndex >= bubbles.length - 1) autoDirection = -1;
          else if (activeIndex <= 0) autoDirection = 1;

          activeIndex += autoDirection;
          const target = bubbles[activeIndex];
          if (!target) return;

          viewport.scrollTo({ top: target.offsetTop - track.offsetTop, behavior: 'smooth' });
        }, 6500);
      };

      const resumeLater = () => {
        stopAuto();
        if (userControlled || component.dataset.mdlcBubblesManual === 'true' || hasOpenBubble()) return;
        resumeTimer = window.setTimeout(startAuto, 10000);
      };

      const centerBubble = (bubble) => {
        window.requestAnimationFrame(() => {
          const targetTop = bubble.offsetTop - track.offsetTop - Math.max(0, (viewport.clientHeight - bubble.offsetHeight) / 2);
          viewport.scrollTo({ top: targetTop, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      };

      const updateOpenState = (bubble) => {
        const shouldOpen = !bubble.open;
        const applyState = () => {
          bubbles.forEach((item) => {
            if (item !== bubble) item.open = false;
          });
          bubble.open = shouldOpen;
        };

        takeManualControl();
        applyState();

        window.requestAnimationFrame(() => {
          viewport.classList.toggle('has-open-bubble', shouldOpen);
          if (shouldOpen) centerBubble(bubble);
          else resumeLater();
        });
      };

      bubbles.forEach((bubble) => {
        const summary = bubble.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          updateOpenState(bubble);
        });
      });

      viewport.addEventListener('pointerenter', () => {
        pointerInside = true;
        stopAuto();
      });

      viewport.addEventListener('pointerleave', () => {
        pointerInside = false;
        resumeLater();
      });

      viewport.addEventListener('pointerdown', takeManualControl, { passive: true });
      viewport.addEventListener('touchstart', takeManualControl, { passive: true });
      viewport.addEventListener('touchend', resumeLater, { passive: true });
      viewport.addEventListener('wheel', takeManualControl, { passive: true });

      startAuto();
    };

    const setupAll = () => document.querySelectorAll('[data-mdlc-bubbles]').forEach(setupBubbles);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll, { once: true });
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', setupAll);

    if (!window.mdlcBubblesObserver) {
      window.mdlcBubblesObserver = new MutationObserver(() => window.requestAnimationFrame(setupAll));
      window.mdlcBubblesObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeStickyAtc = () => {
      const stickyBar = document.querySelector('[data-sticky-atc]');
      const mainProduct = document.querySelector('product-info[id^="MainProduct-"]');

      if (!stickyBar || !mainProduct || stickyBar.dataset.initialized === 'true') return;

      const sectionId = mainProduct.dataset.section;
      const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
      const stickyLabel = stickyBar.querySelector('[data-sticky-atc-label]');
      const stickyPrice = stickyBar.querySelector('[data-sticky-atc-price]');
      const stickyVariant = stickyBar.querySelector('[data-sticky-atc-variant]');
      const stickyImage = stickyBar.querySelector('.sticky-atc__thumb');

      if (!mainButton || !stickyButton || !stickyLabel || !stickyPrice) return;

      stickyBar.dataset.initialized = 'true';

      const setVisible = (visible) => {
        const shouldShow = Boolean(visible);
        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', String(!shouldShow));
        stickyButton.tabIndex = shouldShow ? 0 : -1;
      };

      const updateVisibility = () => {
        const buttonBounds = mainButton.getBoundingClientRect();
        setVisible(buttonBounds.bottom < 0);
      };

      const syncButton = () => {
        const nativeLabel = mainButton.querySelector('span')?.textContent.trim();
        stickyButton.disabled = mainButton.disabled;
        stickyLabel.textContent =
          nativeLabel ||
          (mainButton.disabled ? stickyBar.dataset.soldOutLabel : stickyBar.dataset.addLabel);
      };

      const updatePrice = (html) => {
        const priceWrapper = html?.getElementById(`price-${sectionId}`);
        const priceRoot = priceWrapper?.querySelector('.price');
        const selector = priceRoot?.classList.contains('price--on-sale')
          ? '.price-item--sale'
          : '.price-item--regular';
        const priceText = priceWrapper?.querySelector(selector)?.textContent.trim();

        if (priceText) stickyPrice.textContent = priceText;
      };

      const updateVariant = (variant) => {
        if (!stickyVariant) return;

        const variantTitle = variant?.public_title || variant?.title || '';
        const isDefault = !variantTitle || variantTitle.toLowerCase() === 'default title';

        stickyVariant.hidden = isDefault;
        stickyVariant.textContent = isDefault ? '' : variantTitle;
      };

      const updateImage = (variant) => {
        if (!stickyImage) return;

        const galleryImage =
          mainProduct.querySelector('#mdlc-main-img') ||
          mainProduct.querySelector('.product__media-item.is-active img');
        const source =
          galleryImage?.currentSrc ||
          galleryImage?.src ||
          variant?.featured_media?.preview_image?.src;

        if (!source) return;

        const imageUrl = new URL(source, window.location.origin);
        imageUrl.searchParams.set('width', '112');
        stickyImage.src = imageUrl.toString();
        stickyImage.srcset = `${imageUrl.toString()} 112w`;
      };

      stickyButton.addEventListener('click', () => {
        if (mainButton.disabled) return;
        mainButton.click();
        requestAnimationFrame(syncButton);
      });

      new MutationObserver(syncButton).observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          ([entry]) => {
            setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
          },
          { threshold: 0 }
        ).observe(mainButton);
      } else {
        window.addEventListener('scroll', updateVisibility, { passive: true });
      }

      window.addEventListener('resize', updateVisibility, { passive: true });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event?.data;
          if (!data || data.sectionId !== sectionId) return;

          const sourceButton = data.html?.getElementById(`ProductSubmitButton-${sectionId}`);
          const sourceLabel = sourceButton?.querySelector('span')?.textContent.trim();

          stickyButton.disabled = sourceButton?.hasAttribute('disabled') ?? !data.variant?.available;
          stickyLabel.textContent =
            sourceLabel ||
            (data.variant?.available
              ? stickyBar.dataset.addLabel
              : data.variant
                ? stickyBar.dataset.soldOutLabel
                : stickyBar.dataset.unavailableLabel);

          updatePrice(data.html);
          updateVariant(data.variant);
          window.setTimeout(() => updateImage(data.variant), 250);
        });
      }

      syncButton();
      window.setTimeout(() => updateImage(), 250);
      updateVisibility();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeStickyAtc, { once: true });
    } else {
      initializeStickyAtc();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
